import React, { useState, useRef } from 'react'

// Deps
import config from 'config'

// Partials
import Btn from 'views/shared/partials/btn'
import Image from 'views/shared/partials/image'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Services
import companyServices from 'services/company'


const AnnouncementModal = ({announcement, close, onSuccess, ...props}) => {
	const imageInput = useRef();

	const [submitting, setSubmitting] = useState(false);

	const submit = (formData) => {
		setSubmitting(true);

		if(announcement) {
			companyServices.updateAnnouncement(
				announcement.id,
				formData.title,
				formData.description,
				formData.image,
			).then(() => {
				onSuccess();
				close();
			}).catch(() => {
				imageInput.current.reset();
				setSubmitting(false);
			})
		}
		else {
			companyServices.createAnnouncement(
				formData.title,
				formData.description,
				formData.image,
			).then(() => {
				onSuccess();
				close();
			}).catch(() => {
				imageInput.current.reset();
				setSubmitting(false);
			})
		}
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">{announcement ? 'Duyuru Düzenle' : 'Yeni Duyuru'}</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content loader-container">
				<div className="grid-container">
					<div className="row">
						<div className="col">
							<FormInput
								type="text"
								disabled={submitting}
								label="Başlık"
								autoComplete="announcement-title"
								name="title"
								value={announcement ? announcement.title : undefined}
								validation={{
									required: 'Bir başlık girmelisiniz.',
								}} />
						</div>
					</div>
					<div className="row">
						<div className="col">
							<FormInput
								type="textarea"
								rows={3}
								disabled={submitting}
								label="Mesaj"
								autoComplete="announcement-description"
								name="description"
								value={announcement ? announcement.description : undefined}
								validation={{
									required: 'Bir mesaj girmelisiniz.',
								}} />
						</div>
					</div>
					<div className="row">
						<div className="col">
							<FormInput
								disabled={submitting}
								type="file"
								label="Duyuru görseli"
								placeholder=""
								ref={(ref) => { imageInput.current = ref}}
								validation={{
									required: 'Bir dosya girilmeli',
									fileSize: ['Dosya boyutu en fazla {maxSize} olabilir.', 1024],
									fileFormat: [true, ['image/jpeg', 'image/png', 'image/gif']],
								}}
								name="image" />
								<div className="form-note">Duyuru görselini png/jpeg/gif formatında yüklemelisiniz.</div>

								{announcement && announcement.image &&
									<div className="section announcement-imagepreview">
										<Image
											bg contain
											src={config.cdnUrl + 'announcement_images/' + announcement.image}
											className="imagepreview-logo" />
									</div>
								}
						</div>
					</div>
				</div>
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting}
					type="submit">
					{announcement ? 'Kaydet' : 'Oluştur'}
				</Btn>
			</div>
		</InputForm>
	)
}

AnnouncementModal.defaultProps = {
	className: '',
	containerClass: 'modal-announcement mobile-full',
	name: 'announcement',
	announcement: false,
}

export default AnnouncementModal